module.exports = __webpack_public_path__ + "img/Boy_020007.f3ede652.png";